import { BadgeCheck, MessageCircle, ShieldCheck, Sparkles, Tags } from "lucide-react";

const strengths = [
  {
    icon: ShieldCheck,
    title: "UV Protection",
    desc: "Membantu menjaga kejernihan material dan mengurangi risiko perubahan warna saat digunakan pada area indoor maupun outdoor.",
  },
  {
    icon: Tags,
    title: "Harga Kompetitif",
    desc: "Pilihan tepat untuk kebutuhan proyek, produksi signage, display, dan pembelian jumlah besar dengan kualitas tetap terjaga.",
  },
  {
    icon: Sparkles,
    title: "Tampilan Jernih & Mengilap",
    desc: "Permukaan acrylic terlihat bersih, glossy, dan cocok untuk aplikasi visual yang membutuhkan hasil rapi.",
  },
  {
    icon: MessageCircle,
    title: "Dukungan Tim Sales",
    desc: "Tim kami siap membantu cek stok, warna, ketebalan, dan kebutuhan pengiriman sesuai permintaan proyek.",
  },
];

export const AcrylicStrengths = () => {
  return (
    <section className="py-20 lg:py-28 bg-white" data-testid="acrylic-strengths">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="tag-uppercase text-animax-orange mb-4">Keunggulan ANIMAX Acrylic</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-animax-black">
              UV Protection dan harga kompetitif untuk kebutuhan proyek
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-neutral-600 text-lg leading-relaxed">
              ANIMAX Acrylic dirancang untuk membantu menjaga tampilan material tetap prima,
              sekaligus memberi nilai pembelian yang baik untuk produksi, retail, dan kebutuhan
              proyek skala besar.
            </p>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {strengths.map((item, index) => (
            <article
              key={item.title}
              data-testid={`acrylic-strength-${index}`}
              className="p-6 rounded-2xl border border-neutral-200 bg-white card-lift"
            >
              <div className="w-12 h-12 rounded-xl bg-animax-yellow/20 flex items-center justify-center mb-5">
                <item.icon className="w-5 h-5 text-animax-orange" />
              </div>
              <h3 className="font-display text-xl font-medium text-animax-black">{item.title}</h3>
              <p className="mt-3 text-sm text-neutral-600 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 rounded-2xl bg-animax-black text-white p-6 lg:p-8 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 rounded-xl bg-animax-yellow/20 flex items-center justify-center shrink-0">
              <BadgeCheck className="w-5 h-5 text-animax-yellow" />
            </div>
            <div>
              <h3 className="font-display text-2xl font-medium">Kualitas visual yang siap dipakai</h3>
              <p className="mt-2 text-sm text-white/65 leading-relaxed max-w-2xl">
                Cocok untuk signage, display, interior, furniture, dekorasi, dan aplikasi visual
                yang membutuhkan acrylic rapi dengan dukungan harga yang masuk untuk proyek.
              </p>
            </div>
          </div>
          <a
            href="#tim-sales"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-animax-yellow text-animax-black text-sm font-medium hover:bg-animax-orange hover:text-white transition-all shrink-0"
          >
            Tanya Harga Proyek
            <MessageCircle className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};
